// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2F3Sx","header":"Messages_header__3gx5u"};